import BlockComponentMap from '../../../models/BlockComponentValues/BlockComponentMap';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

export enum IFrameServiceType {
  GOOGLE_MAP = 'googleMap',
  YOUTUBE = 'youtube',
  INSTAGRAM = 'instagram',
}

class BlockiFrameSafeData {
  html: BlockComponentMap;
  text: BlockComponentText;
  url?: BlockComponentImage;
  serviceType?: IFrameServiceType;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockiFrameSafeData {
  export function make(
    html?: string,
    text?: string,
    url?: string,
    serviceType?: IFrameServiceType,
  ): BlockiFrameSafeData {
    return {
      html: BlockComponentMap.make(html),
      text: text ? BlockComponentText.make(text) : undefined,
      url: BlockComponentImage.make(url),
      serviceType: serviceType ?? IFrameServiceType.GOOGLE_MAP,
    };
  }

  export function getDefault(
    html: string = undefined,
    text = '説明文',
  ): BlockiFrameSafeData {
    return make(html, text, undefined, IFrameServiceType.GOOGLE_MAP);
  }
}

export default BlockiFrameSafeData;
